export function getSearchParam(param: string) {
  if (typeof window === "undefined") {
    return undefined;
  }
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(param);
}

export function addSearchParams(params: { param: string; value: string }[]) {
  if (typeof window === "undefined") {
    return undefined;
  }
  const searchParams = new URLSearchParams(document.location.search);
  params.forEach((p) => searchParams.set(p.param, p.value));
  window.history.pushState(
    null,
    "",
    `${window.location.pathname}?${searchParams.toString()}`
  );
}

export function removeSearchParams(params: { param: string }[]) {
  if (typeof window === "undefined") {
    return undefined;
  }
  const searchParams = new URLSearchParams(document.location.search);
  params.forEach((p) => searchParams.delete(p.param));
  window.history.pushState(
    null,
    "",
    `${window.location.pathname}?${searchParams.toString()}`
  );
}
